{
  "longPressMessage": "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
}
